module.exports = __webpack_public_path__ + "static/media/server.7420ea75.svg";